module.exports = __webpack_public_path__ + "img/UY.976764bb.svg";